import { render, staticRenderFns } from "./CardCreateTemplates.vue?vue&type=template&id=9f67f3bc"
import script from "./CardCreateTemplates.vue?vue&type=script&lang=js"
export * from "./CardCreateTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports